<template>
  <div v-if="reports?.length" class="space-y-3">
    <div v-for="report in reports" :key="report.id">
      <ReportCard 
        :report="report" 
        :show-actions="showActions"
        @report-updated="handleReportUpdated"
      />
    </div>
  </div>
  <div v-else-if="showEmpty" class="text-sm text-gray-500 text-center py-4">
    No reports found.
  </div>
</template>

<script setup lang="ts">
import ReportCard from '@/components/manage/ReportCard.vue'
import type { Report, FellowReport } from '@/types/reports'

interface Props {
  reports?: (Report | FellowReport)[]
  showActions?: boolean
  showEmpty?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  reports: () => [],
  showActions: true,
  showEmpty: true
})

const emit = defineEmits<{
  (e: 'report-updated', report: Report | FellowReport): void
}>()

const handleReportUpdated = (updatedReport: Report | FellowReport) => {
  emit('report-updated', updatedReport)
}
</script> 